// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var MM_cmp_proof_node = require("./MM_cmp_proof_node.bs.js");

function makeInitialState(wrkCtx, rootStmts) {
  return {
          ctxMaxVar: MM_context.getNumOfVars(wrkCtx) - 1 | 0,
          exprToLabel: Belt_HashMap.fromArray(rootStmts.map(function (stmt) {
                    return [
                            stmt.expr,
                            stmt.label
                          ];
                  }), MM_context.ExprHash)
        };
}

function MM_cmp_proof_tree(Props) {
  var tree = Props.tree;
  var rootExpr = Props.rootExpr;
  var wrkCtx = Props.wrkCtx;
  var rootStmts = Props.rootStmts;
  var match = React.useState(function () {
        return makeInitialState(wrkCtx, rootStmts);
      });
  var state = match[0];
  var nodeIdxToLabel = function (idx) {
    var label = Belt_HashMap.get(state.exprToLabel, Caml_array.get(tree.nodes, idx).expr);
    if (label !== undefined) {
      return label;
    } else {
      return String(idx);
    }
  };
  var intToSym = function (i) {
    if (i <= state.ctxMaxVar) {
      return MM_context.ctxIntToSymExn(wrkCtx, i);
    } else {
      return "&" + String(i);
    }
  };
  var exprToStr = function (expr) {
    return expr.map(intToSym).join(" ");
  };
  var exprToReElem = function (expr) {
    return React.createElement("span", undefined, exprToStr(expr));
  };
  var frmExprToStr = function (asrtLabel, expr) {
    var frame = MM_context.getFrame(wrkCtx, asrtLabel);
    if (frame !== undefined) {
      return MM_context.frmIntsToStrExn(wrkCtx, frame, expr);
    }
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot find an assertion by label '" + asrtLabel + "'"
          },
          Error: new Error()
        };
  };
  var isRootStmt = function (idx) {
    return Belt_HashMap.has(state.exprToLabel, Caml_array.get(tree.nodes, idx).expr);
  };
  var nodeIdx = tree.nodes.findIndex(function (node) {
        return MM_context.exprEq(node.expr, rootExpr);
      });
  if (nodeIdx !== -1) {
    return React.createElement(MM_cmp_proof_node.make, {
                tree: tree,
                nodeIdx: nodeIdx,
                isRootStmt: isRootStmt,
                nodeIdxToLabel: nodeIdxToLabel,
                exprToStr: exprToStr,
                exprToReElem: exprToReElem,
                frmExprToStr: frmExprToStr
              });
  } else {
    return "The proof tree doesn't contain expression [" + exprToStr(rootExpr) + "]";
  }
}

var make = MM_cmp_proof_tree;

exports.makeInitialState = makeInitialState;
exports.make = make;
/* react Not a pure module */
